interface SortOptions {
  column: string;
  sortBy: string[];
  sortOrder: string;
}

const TICKET_SORT_VALUES = {
  room: [ 'roomName' ],
  name: [ 'lastName', 'firstName' ],
  institution: [ 'organisation' ],
  email: [ 'email' ],
  date: [ 'date', 'startTime' ]
}

function createDefaultTicketSortOptions(): SortOptions {
  return createTicketSortOptions('name')
}

function createTicketSortOptions(column: string, descending = false): SortOptions {
  if (!column) {
    return createDefaultTicketSortOptions()
  }
  return {
    column: column,
    sortBy: (TICKET_SORT_VALUES as any)[column] as string[],
    sortOrder: descending ? 'desc' : 'asc'
  }
}

export {
  SortOptions,
  createDefaultTicketSortOptions,
  createTicketSortOptions,
  TICKET_SORT_VALUES
}
